import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GenericService } from '../../common/services/GenericServices';
import { List } from 'lodash';
import { ProfileLevel } from '../../common/models/ProfileLevel.Model';
import { Container } from '../../common/models/Container.Model';
import { LabelDetail } from '../../common/models/LabelDetail.Model';
import { Label } from '../../common/models/Label.Model';
import { Ceve } from '../../common/models/Ceve.Model';


@Injectable({
  providedIn: 'root'
})
export class LabelService {

  constructor(private genericService: GenericService) { }

  getCevesByUser(userId: number): Observable<Ceve[]> {
    return this.genericService.getRequest(`ceve/getByUser/${userId}`, {});
  }

  /**
   * Returns an observable with a list of units assigned to profile user
   * @param userId
   */
  getProfileLevel(userId: number): Observable<List<ProfileLevel>> {
    return this.genericService.getRequest(`userprofile/level/${userId}/CEVE`, {}, 0);
  }

  /**
   * Returns an observable with a list of units assigned to profile user
   * @param userId
   */
  getContainers(cont: string): Observable<List<Container>> {
    let url = "Container/GetContainer/" + cont;
    return this.genericService.getRequest(url, {});
  }

  getLabels(): Observable<List<Label>> {
    let url = "Label/";
    return this.genericService.getRequest(url, {});
  }

  getCeveLabels(ceveId: number): Observable<List<Label>> {
    let url = "Label/" + ceveId;
    return this.genericService.getRequest(url, {});
  }

  UpdateLabel (label: any): Observable<List<Label>> {
    let url = "Label";
    return this.genericService.putRequest(url, {}, 0, label);
  }

  addLabel(labelDto: any): Observable<any> {
    let url = "Label";
    return this.genericService.postRequest(url, {}, 0, labelDto);
  }

  LabelsValid(labels: string[]): Observable<any> {
    return this.genericService.postRequest('labeldetail/labelsvalid', {}, 0, labels);
  }

   /**
   * Gets label data to print from database
   *
   
    getLabelPrintedPdf( getPdf: boolean = false): Observable<any> {
      return this.genericService.getPdfRequest(`label/print/${getPdf}`, {}, 0);
    }
  */
}
